export default __webpack_public_path__ + "02caf7631fd665595fc09de4aeb6a7e4.png";